module.exports = __webpack_public_path__ + "static/img/available-boxs.d827f61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/available-boxs.svg
// module id = CX6k
// module chunks = 134